import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import { useTreeMap } from './hooks/useTreeMap';

export const TreeMap = ({ title, values, subtitles, className = '' , colors , height = 350}) => {
    const { chartConfig } = useTreeMap({
        values,
        subtitles,
        colors
    });

    return (
        <ChartContainer
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            type="treemap"
            height={height}
            className={`${className}`}
        />
    );
};
